module.exports = __webpack_public_path__ + "img/DE01728.4e8f6f06.png";